import React from "react";
import Config from "../../../config/config";
import ErrorModal from "../../../components/Modal/ErrorModal";
import { Row, Col } from "react-bootstrap";
import { Query } from "react-apollo";
import { addToDataLayerGTM } from "../../../utils/addToDataLayerGTM";
import { cms_client, GET_TESTIMONY } from "../apollo";

const Highlights = () => (
  <div className="bg-gray">
    <div className="content">
      <div className="container">
        <Row>
          <Query client={cms_client} query={GET_TESTIMONY}>
            {({ loading, error, data }) => {
              if (loading) return <div />;
              if (error) {
                // Google Tag Manager
                addToDataLayerGTM({
                  'event': 'erro',
                  'descricao': 'erro ao buscar GET_TESTIMONY'
                });
                return <ErrorModal />;
              }
              if (!data.contents_collections.contents.length) {
                return <span />;
              }
              return (
                <div>
                  <Row>
                    <Col md={12}>
                      <h2>Destaques</h2>
                    </Col>
                    {data.contents_collections.contents.map(item => (
                      <Col md={3}>
                        <a
                          data-gtm-type="click"
                          data-gtm-clicktype="card"
                          data-gtm-name={item.title}
                          href={item.directlink}
                          target="_blank"
                        >
                          <div className="depoiment">
                            <img
                              src={
                                Config.baseUrl + "/cms/assets/" + item.thumbnail
                              }
                            />
                            <div>
                              <br />
                              <b>{item.title}</b>
                            </div>
                            <div>
                              <br />
                              {item.content}
                            </div>
                          </div>
                        </a>
                      </Col>
                    ))}
                  </Row>
                </div>
              );
            }}
          </Query>
        </Row>
      </div>
    </div>
  </div>
);

export default Highlights;



// WEBPACK FOOTER //
// ./src/views/Home/components/Highlights.jsx